/* @flow */

import { type GetState, type State } from '../../preact-app/types';
import { type IntervaloData } from '../../utils/types';
import * as intervaloDataActions from '../intervalo-data';
import relatorios, { type ProdutosMaisVendidos } from '../../relatorios/relatorios';
import { type ProdutosMaisVendidosState } from './produtos-mais-vendidos-types';

type SetDadosAction = {
    type: 'relatorios/produtos-mais-vendidos/SET_DADOS',
    dados: ProdutosMaisVendidos[],
};

type LoadingAction = {
    type: 'relatorios/produtos-mais-vendidos/LOADING',
    isLoading: boolean,
};

type Actions = SetDadosAction | LoadingAction;

// Action Types

const SET_DADOS = 'relatorios/produtos-mais-vendidos/SET_DADOS';
const LOADING = 'relatorios/produtos-mais-vendidos/LOADING';

// Action creators

const setDados = (dados: ProdutosMaisVendidos[]): SetDadosAction => ({
    type: SET_DADOS,
    dados,
});

const loading = (isLoading: boolean): LoadingAction => ({
    type: LOADING,
    isLoading,
});

// Selectors

const getProdutosMaisVendidos = (state: State) => state.relatorios.produtosMaisVendidos;
export const getDados = (state: State) => getProdutosMaisVendidos(state).dados;
export const isLoading = (state: State) => getProdutosMaisVendidos(state).isLoading;

// Thunks

export const buscar = () => (dispatch: Function, getState: GetState) => {
    const intervalo = intervaloDataActions.getIntervalo(getState());
    return Promise.resolve()
        .then(dispatch(loading(true)))
        .then(() => relatorios.calcularProdutosMaisVendidos(intervalo))
        .then(({ data }) => dispatch(setDados(data)))
        .then(dispatch(loading(false)));
};

export const setIntervalo = (
    intervaloData: IntervaloData,
) => (dispatch: Function) => {
    dispatch(intervaloDataActions.setIntervalo(intervaloData));
    return dispatch(buscar());
};

// Reducer

const initialState = {
    dados: [],
    isLoading: false,
};

const produtosMaisVendidosReducer = (
    state: ProdutosMaisVendidosState = initialState,
    action: Actions,
): ProdutosMaisVendidosState => {
    switch (action.type) {
    case SET_DADOS: {
        const { dados } = action;
        return { ...state, dados };
    }
    case LOADING: {
        return { ...state, isLoading: action.isLoading };
    }
    default:
        return state;
    }
};

export default produtosMaisVendidosReducer;
